/* eslint-disable */
var platform_mi = 'com.xiaomi.hm.health'; // xiaomi
var platform_midong = 'com.huami.midong'; // midong
var platform_watch = 'com.huami.watch'; // watch
var platform_amazfit = 'com.huami.watch.hmwatchmanager'; // Zepp
var platform_amazfit_backup = 'com.huami.app.amazfit'; // 备份 Amazfit
var platform_timex = 'com.timex.app'; // Timex
var platform_bell = 'com.huami.hearingaids'; // bell

var versionReg = {
  mi: /com\.xiaomi\.hm\.health\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  midong: /com\.huami\.midong\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  watch: /com\.huami\.watch\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  amazfit: /com\.huami\.watch\.hmwatchmanager\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  zepp: /com\.huami\.watch\.hmwatchmanager\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  timex: /com\.timex\.app\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/,
  bell: /com\.huami\.hearingaids\/(\d+)?_?((\d+)\.?(\d+)?\.?(\d+)?)/
};

var deviceInfoReg = {
  netType: /\snettype\/(\S+)/,
  region: /\suserregion\/(\S+)/,
  language: /\slanguage\/(\S+)/,
  country: /\scountry\/(\S+)/
};

var Appname = {
  mi: 'com.xiaomi.hm.health',
  midong: 'com.huami.shushan',
  watch: 'com.huami.watch',
  amazfit: 'com.huami.app.amazfit',
  zepp: 'com.huami.midong',
  timex: 'com.timex.app',
  bell: 'com.huami.hearingaids'
};

var userAgent = '';

if (typeof window !== 'undefined') {
  var navigator = window.navigator;
  userAgent = navigator.userAgent.toLowerCase();
}

// @TODO support com.huami.webapp
function getAppDevice(_userAgent) {
  var ua = userAgent || _userAgent || '';

  if (ua.indexOf(platform_mi) >= 0) return 'mi';
  if (ua.indexOf(platform_midong) >= 0) return 'midong';

  if (ua.indexOf(platform_amazfit) >= 0) {
    var version = getMifitVersion('amazfit', _userAgent);
    if (version && version.name >= '3.0.0' && version.name < '5.0.0') {
      return 'amazfit';
    }
    return 'zepp';
  }

  if (ua.indexOf(platform_watch) >= 0) return 'watch';
  if (ua.indexOf(platform_amazfit_backup) >= 0) return 'amazfit';
  if (ua.indexOf(platform_timex) >= 0) return 'timex';
  if (ua.indexOf(platform_bell) >= 0) return 'bell';

  return 'webview';
}

function getAppName(def) {
  var appDevice = getAppDevice(userAgent);
  return Appname[appDevice] || Appname[def];
}

function getMifitVersion(platform, _userAgent) {
  var reg = versionReg[platform];
  var ua = userAgent || _userAgent || '';
  var matched = ua.match(reg);

  if (matched && matched.length === 6) {
    return {
      code: Number(matched[1]),
      name: matched[2],
      v: Number(matched[3]),
      int:
        Number(matched[3]) * 1000 +
        Number(matched[4]) * 10 +
        Number(matched[5])
    };
  }
  return null;
}

// 参考：https://api-doc.huami.com/api/aos/wiki/#social
function getSocial(_userAgent) {
  var ua = userAgent || _userAgent || '';

  if (ua.indexOf(platform_mi) >= 0) return 'mi';
  if (ua.indexOf(platform_midong) >= 0) return 'midong';
  if (ua.indexOf(platform_amazfit) >= 0) return 'watch';
  if (ua.indexOf(platform_watch) >= 0) return 'watch';
  if (ua.indexOf(platform_amazfit_backup) >= 0) return 'amazfit';

  return 'mi';
}

function setUserAgent(ua) {
  userAgent = ua;
}

function getDeviceInfo(_userAgent) {
  var result = {};
  var ua = userAgent || _userAgent || '';

  for (var key in deviceInfoReg) {
    if (deviceInfoReg.hasOwnProperty(key)) {
      var matched = ua.match(deviceInfoReg[key]) || [];
      result[key] = matched[1];
    }
  }
  return result;
}

var device = {
  getAppDevice: getAppDevice,
  getAppName: getAppName,
  getMifitVersion: getMifitVersion,
  isIos: userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1,
  isAndroid: userAgent.indexOf('android') !== -1,
  getSocial: getSocial,
  getDeviceInfo: getDeviceInfo,
  setUserAgent: setUserAgent
};

